import React, { Component } from 'react';
import {connect} from 'react-redux';
import styled from 'styled-components'
import * as C from "../store/constants";
import Zahod from "../assets/img/zahod.png";
import Pattern from "../assets/img/pattern.jpg";


const MainBackGroundContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0.7) 100%), url(${Zahod}) center bottom;
  background-position: top;
  background-size: cover;
  background-color: black;
  
  @media (max-width: 920px) {
    width: 100%;
    background-position: 0;
  }
`;


const PatternBackGroundContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url(${Pattern});
  background-color: rgba(14, 6, 6, 0.7);
  background-blend-mode: normal;
  opacity: 0.4;
  background-position: 1px 73px;
  background-repeat: repeat;
  background-size: 250px;
`;

@connect(state => {
  return {
    route: state.game.route
  }
})
class MainBackground extends Component {
  render() {
    const isWellcomePage = this.props.route === C.ROUTE_START;

    if(isWellcomePage) return <MainBackGroundContainer />;

    return (
      <PatternBackGroundContainer />
    );
  }
}

export default MainBackground;
